<template>
  <a
    data-toggle="tooltip"
    :title="title"
    :data-placement="placement"
    class="info"
    style="cursor: pointer;"
  >
    <slot />
  </a>
</template>

<script>
import 'bootstrap/js/src/tooltip';

export default {
  name: 'Tooltip',
  props: {
    title: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: '',
    },
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
  },
};
</script>
